<template>
    <a-select
            :get-popup-container="getPopupContainer"
            :placeholder="customPlaceholder"
            :mode="multiple?'multiple':null"
            :value="valueArray"
            @update:value="onUpdateValue"
            style="width: 100%"
    >
        <a-select-option
                v-for="item in options"
                :key="item[fieldNames.value]"
                :value="item[fieldNames.value]"
        >
            {{ item[fieldNames.label] }}
        </a-select-option>
    </a-select>
</template>

<script>
import {computed, onMounted, ref} from "vue";
import {getAction} from "@/utils/http/service";
import {common_controller} from "@/api/commonService";

export default {
    name: "DictSelect",
    emits: ["update:value"],
    props: {
        customPlaceholder: {
      type: String,
      default: '请选择'
    },
        value: {
            type: [String, Number, undefined, null],
            default: null,
        },
        fieldNames: {
            type: Object,
            default() {
                return {
                    label: "dictLabel",
                    value: "dictValue"
                }
            }
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        dictName: {
            type: String,
            default: ""
        },
    },
    setup(props, {emit}) {
        const options = ref([]);
        onMounted(() => {
            getAction({
                url: common_controller.getDictDataByGroupNumber,
                params: {
                    groupNumbers: props.dictName
                }
            }).then(res => {
                options.value = res;
            })
        })

        const valueArray = computed(() => {
                let value=  props.multiple
                    ? props.value ? props.value.split(",") : []
                    : props.value;
                if(typeof (value)== 'number'){
                    return value + ''
                } else {
                    return value
                }
            }
        );
        const onUpdateValue = (val) => {
            let value = props.multiple ? val.join(",") : val;
            emit("update:value", value);
        };
        return {
            options,
            valueArray,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
